{
  "$schema": "https://cdn.us-east-1.prod.moon.dubai.aws.dev/wPjwkduJWkX3/PP8ofMnZY5LC/latest/schemas/settings-schema.json/index.json",
  "color-mode": {
    "type": "select",
    "label": "Color Mode",
    "config": {
      "default": "light",
      "options": [
        { "label": "Light Mode", "value": "light" },
        { "label": "Dark Mode", "value": "dark" }
      ]
    }
  },
  "badge-size": {
    "type": "select",
    "label": "Badge Size",
    "config": {
      "default": "medium",
      "options": [
        { "label": "Extra Small", "value": "extra-small" },
        { "label": "Small", "value": "small" },
        { "label": "Medium", "value": "medium" },
        { "label": "Large", "value": "large" },
        { "label": "Extra Large", "value": "extra-large" }
      ]
    }
  },
  "disclosure-font-size": {
    "type": "select",
    "label": "Disclosure Font Size",
    "config": {
      "default": "medium",
      "options": [
        { "label": "Extra Small", "value": "extra-small" },
        { "label": "Small", "value": "small" },
        { "label": "Medium", "value": "medium" },
        { "label": "Large", "value": "large" },
        { "label": "Extra Large", "value": "extra-large" }
      ]
    }
  },
  "font-family": {
    "type": "select",
    "label": "Font Family",
    "config": {
      "default": "amazon-ember",
      "options": [
        { "label": "Amazon Ember", "value": "amazon-ember" },
        { "label": "Fira Sans", "value": "fira-sans" },
        { "label": "Inter", "value": "inter" },
        { "label": "Source Serif Pro", "value": "source-serif-pro" }
      ]
    }
  },
  "product-sku": {
    "type": "text",
    "label": "Product SKU",
    "config": {
      "default": null
    }
  },
  "product-external-id": {
    "type": "text",
    "label": "Product External ID",
    "config": {
      "default": null
    }
  },
  "product-id": {
    "type": "text",
    "label": "Product Id",
    "config": {
      "default": null
    }
  },
  "mock-roa": {
    "type": "text",
    "label": "Mock ROA Instance ID (for testing)",
    "config": {
      "default": null
    }
  },
  "use-mock-cpf-data": {
    "type": "text",
    "label": "Use Mock CPF Data (for testing)",
    "config": {
      "default": null
    }
  },
  "bypass-cors": {
    "type": "text",
    "label": "Bypass CORS (gamma only, for testing)",
    "config": {
      "default": null
    }
  },
  "badge-title": {
    "type": "select",
    "label": "Badge Title",
    "config": {
      "default": "feature-forward",
      "options": [
        {
          "label": "Feature Forward (e.g. 'Organic Content')",
          "value": "feature-forward"
        },
        {
          "label": "Feature Count (e.g. '3 sustainability features')",
          "value": "feature-count"
        }
      ]
    }
  }
}
